import React from "react";
import { useAuth, useLoading } from "../Context/Contexts";
import {
    LoginForm, HomePage, OrderList, EditOrderPage, CustomerList,
    CustomerEditPage, ItemList, ItemEditPage, ItemGroup, ItemCategory, ProductGroup,
    Program, Collection, Gender, MetricsViewPage, SystemLogListPage, SystemLogArchivePage, SupplierEditPage, SupplierList, LocationList, LocationEditPage, CurrencyList, CurrencyEditPage,
    LanguageList, LanguageEditPage, ShopList, ShopEditPage, ShippingAgentList, ShippingAgentEditPage, ShippingServiceList, ShippingServiceEditPage,
    ShippingServiceJsonEditPage, CountryList, CountryEditPage, CompanyList, CompanyEditPage, UserList, UserEditPage, PrinterList, PrinterEditPage,
    SalespersonList, SalespersonEditPage, StatnoList, StatnoEditPage, TerminalList, TerminalEditPage, ColourGroupList, ColourGroupEditPage, SizeGroupList, SizeGroupEditPage, LengthGroupList, LengthGroupEditPage,
    PaymentTerminalList, PaymentTerminalEditPage, AccountList, AccountEditPage, PostingSetupList, PostingSetupEditPage, SalesDocumentHistoryPage, HistorySalesDocumentList, ShipmentList, ShipmentDocumentEditPage, SalesItemReportPage,
    ItemLedgerPage, InventoryJournalList, InventoryJournalEditPage, LabelJournalList, LabelJournalEditPage, SuccessSetup, PaymentProviderConfigEditPage, PaymentProviderConfigList, PaymentMethodList, PaymentMethodEditPage,
    InventoryQtyReportPage, InventoryValueReportPage, AccountSummaryReportPage, AccountDimensionReportPage, ItemImportList, ItemImportEditPage, SalesVariantReportPage, ReturnList,
    ReturnEditPage, PickOrderPage, PackOrderPage, BatchListPage, BatchEditPage, CardVoucherList, CardVoucherPage, PricelistListPage, SalesPriceImportPage, FortnoxSetupPage, IntegrationListPage, IntegrationEditPage, BonusBatchPage, BonusSystemListPage, BonusSystemEditPage
} from "../Pages/PageExport";
import { Stack } from "@mui/material";
import { PageComponentProps } from "../Types/ExportTypes";
import { useNavigation } from '../Context/NavigationContext';
const pathToComponentMap: Record<string, React.ComponentType<PageComponentProps>> = {
    //admin and metrics
    'home': HomePage,
    'admin/metrics/view': MetricsViewPage,
    'admin/systemlog/list': SystemLogListPage,
    'admin/systemlog/archive': SystemLogArchivePage,
    'admin/user/list': UserList,
    'admin/user/edit': UserEditPage,

    'inventory/itemledger/transactions': ItemLedgerPage,
    'inventory/journal/list': InventoryJournalList,
    'inventory/journal/edit': InventoryJournalEditPage,
    'inventory/labeljournal/list': LabelJournalList,
    'inventory/labeljournal/edit': LabelJournalEditPage,
    'inventory/journalhistory/list': InventoryJournalList,
    'inventory/journalhistory/edit': InventoryJournalEditPage,
    'integration/fortnox/setup': FortnoxSetupPage,
    'integration/list': IntegrationListPage,
    'integration/edit': IntegrationEditPage,
    //item
    'purchase/item/list': ItemList,
    'purchase/item/edit': ItemEditPage,
    'purchase/item/import/list': ItemImportList,
    'purchase/item/import/edit': ItemImportEditPage,
    'purchase/item/colourgroup/list': ColourGroupList,
    'purchase/item/colourgroup/edit': ColourGroupEditPage,
    'purchase/item/sizegroup/list': SizeGroupList,
    'purchase/item/sizegroup/edit': SizeGroupEditPage,
    'purchase/item/lengthgroup/list': LengthGroupList,
    'purchase/item/lengthgroup/edit': LengthGroupEditPage,
    'purchase/settings/itemgroup': ItemGroup,
    'purchase/settings/itemcategory': ItemCategory,
    'purchase/settings/productgroup': ProductGroup,
    'purchase/settings/program': Program,
    'purchase/settings/collection': Collection,
    'purchase/settings/gender': Gender,
    //Supplier
    'purchase/supplier/list': SupplierList,
    'purchase/supplier/edit': SupplierEditPage,


    //reports
    'report/inventory/qty': InventoryQtyReportPage,
    'report/inventory/value': InventoryValueReportPage,
    'report/finance/accountsummary': AccountSummaryReportPage,
    'report/finance/accountdimension': AccountDimensionReportPage,
    'report/sales/item': SalesItemReportPage,
    'report/sales/variant': SalesVariantReportPage,
    //salesDocument
    'sales/order/list': OrderList,
    'sales/order/edit': EditOrderPage,
    'sales/cardvoucher/list': CardVoucherList,
    'sales/cardvoucher/view': CardVoucherPage,
    'sales/bonus/batch': BonusBatchPage,
    'sales/bonussystem/list': BonusSystemListPage,
    'sales/bonussystem/edit': BonusSystemEditPage,
    'sales/pricelist/list': PricelistListPage,
    'sales/pricelist/import': SalesPriceImportPage,
    'sales/history/documentlist': HistorySalesDocumentList,
    'sales/history/document': SalesDocumentHistoryPage,
    //customer
    'sales/customer/list': CustomerList,
    'sales/customer/edit': CustomerEditPage,
    'sales/return/list': ReturnList,
    'sales/return/edit': ReturnEditPage,
    'sales/shipment/list': ShipmentList,
    'sales/shipment/edit': ShipmentDocumentEditPage,
    //settings
    'settings/account/list': AccountList,
    'settings/account/edit': AccountEditPage,
    'settings/company/list': CompanyList,
    'settings/company/edit': CompanyEditPage,
    'settings/currency/list': CurrencyList,
    'settings/currency/edit': CurrencyEditPage,
    'settings/country/list': CountryList,
    'settings/country/edit': CountryEditPage,
    'settings/language/list': LanguageList,
    'settings/language/edit': LanguageEditPage,
    'settings/location/list': LocationList,
    'settings/location/edit': LocationEditPage,
    'settings/paymentmethod/list': PaymentMethodList,
    'settings/paymentmethod/edit': PaymentMethodEditPage,
    'settings/paymentproviderconfig/list': PaymentProviderConfigList,
    'settings/paymentproviderconfig/edit': PaymentProviderConfigEditPage,
    'settings/paymentterminal/list': PaymentTerminalList,
    'settings/paymentterminal/edit': PaymentTerminalEditPage,
    'settings/postingsetup/list': PostingSetupList,
    'settings/postingsetup/edit': PostingSetupEditPage,
    'settings/printer/list': PrinterList,
    'settings/printer/edit': PrinterEditPage,
    'settings/salesperson/list': SalespersonList,
    'settings/salesperson/edit': SalespersonEditPage,
    'settings/statno/list': StatnoList,
    'settings/statno/edit': StatnoEditPage,
    'settings/shippingagent/list': ShippingAgentList,
    'settings/shippingagent/edit': ShippingAgentEditPage,
    'settings/shippingservice/list': ShippingServiceList,
    'settings/shippingservice/edit': ShippingServiceEditPage,
    'settings/shippingservice/editjson': ShippingServiceJsonEditPage,
    'settings/shop/list': ShopList,
    'settings/shop/edit': ShopEditPage,
    'settings/terminal/list': TerminalList,
    'settings/terminal/edit': TerminalEditPage,
    'success/setup': SuccessSetup,
    'warehouse/pick/edit': PickOrderPage,
    'warehouse/pack/edit': PackOrderPage,
    'warehouse/batch/list': BatchListPage,
    'warehouse/batch/edit': BatchEditPage,


};

const PageRenderer: React.FC = () => {
    const { isAuthenticated } = useAuth();
    const { navigationPath } = useNavigation();
    const {  isLoading } = useLoading();




    if (isAuthenticated == null && !isLoading) {
        return <></>
    }

    if (!isAuthenticated) {
        return <LoginForm />;
    }

    const getCurrentComponent = (): React.ReactNode => {

        const currentStep = navigationPath.at(-1);
        if (!currentStep) return <HomePage />;

        const ComponentToRender = pathToComponentMap[currentStep.path?.toLowerCase() ?? ""];
        if (!ComponentToRender) {

            return <HomePage />;
        }

        return <ComponentToRender params={currentStep.params} />;
    };

    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            sx={{
                mt: 5,
                width: "100%",
                button: {
                    fontSize: "1.25rem",
                    padding: "10px 24px",
                    width: "100%",
                },
            }}
        >
            {getCurrentComponent()}
        </Stack>
    );
};

export default PageRenderer;
